import * as $ from 'jquery';
import PerfectScrollbar from 'perfect-scrollbar';

// Initialize PerfectScrollbar only on intended elements.
// Exclude the main sidebar menu and any element marked with `.no-ps`.
export default (function () {
  let scrollables = $('.scrollable').not('.no-ps');

  // Exclude elements that are inside the main sidebar
  scrollables = scrollables.filter(function () {
    return $(this).closest('.sidebar').length === 0;
  });

  if (scrollables.length > 0) {
    scrollables.each((index, el) => {
      new PerfectScrollbar(el);
    });
  }
}());
